import {
  createRootRoute,
  createRouter,
  Outlet,
  createHashHistory,
} from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import {
  agentRoute,
  smeRoute,
  ahtmonitoringRoute,
  extractionRoute,
  loginRoute,
  reportsRoute,
  supervisorRoute,
  templateEditHeaderRoute,
  templateEditTableRoute,
  templateRoute,
  usersRoute,
  viewWorklistRoute,
  worklistRoute,
  reasoncodeRoute,
  tgesmeRoute,
  EditWorklistRoute,
  globalExceptionRoute,
  businessRuleRoute,
  ServerStatusPageRoute,
  masterReportsRoute
} from "./pages/all-routes";
import { AuthContextProvider } from "./hooks/TGEPE/use-auth";
import { setZoningHttpClient } from "./services/zoning-loader.services";
import { http } from "./services/api.services";

setZoningHttpClient(http);

export const TanStackRouterDevtools =
  process.env.NODE_ENV === "production"
    ? () => null
    : lazy(() =>
        import("@tanstack/router-devtools").then((res) => ({
          default: res.TanStackRouterDevtools,
        }))
      );

export const rootRoute = createRootRoute({
  component: () => (
    <>
      <AuthContextProvider>
        <Outlet />
        <Suspense>
          <TanStackRouterDevtools />
        </Suspense>
      </AuthContextProvider>
    </>
  ),
});

const routeTree = rootRoute.addChildren([
  loginRoute,
  agentRoute,
  smeRoute,
  businessRuleRoute,
  ServerStatusPageRoute,
  supervisorRoute.addChildren([
    worklistRoute,
    viewWorklistRoute,
    usersRoute,
    tgesmeRoute,
    extractionRoute,
    ahtmonitoringRoute,
    templateRoute,
    templateEditHeaderRoute,
    templateEditTableRoute,
    reportsRoute,
    reasoncodeRoute,
    EditWorklistRoute,
    globalExceptionRoute,
    masterReportsRoute
  ]),
]);

const hashRouter = createHashHistory();

export const router = createRouter({ routeTree, history: hashRouter });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
